import { put, delay, takeEvery, all, call, select } from "redux-saga/effects";
import _ from "lodash";
import moment from "moment-timezone";
import {
  setPageTopLoader,
  setA2ESurvey,
} from "actions";
import { getJwtToken, getDataFromRDS, getDataFromSxi } from "api";
import { A2E, ENDPOINT } from "../../constants";
import * as H from "helper";

export const currentPage = (state) => state.page.currentPage;
export const dateRange = (state) => state.a2e.customDateRange;
export const a2eAlias = (state) => state.a2e.alias;
export const currentTab = (state) => state.a2e.reportTab;

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getRandomFloat(min, max) {
  return (Math.random() * (max - min)) + min;
}

export function* getA2eSurvey(action) {
  try {
    yield put(setPageTopLoader(true));
    const jwtToken = yield call(getJwtToken);
    const rangeTarget = yield select(dateRange);

    const sqlGetAllSurvey = {
      query: `
        SELECT
           qbmv.id                AS versioned_quiz_id
          ,qt.text                AS quiz_text
          ,ot.text                AS option_text
          ,COUNT(ar_qa.option_id) AS selection_count
          ,ao.*
        FROM answer_result_of_quiz_with_ad ar_qa
        INNER JOIN answer_result ar ON ar_qa.id = ar.id
        INNER JOIN question_based_method_version qbmv ON ar_qa.question_based_method_version_id = qbmv.id
        INNER JOIN quiz_option qo ON ar_qa.option_id = qo.id
        INNER JOIN quiz_option_text ot ON qo.id = ot.quiz_option_id
        INNER JOIN answer_service_method_bind asm ON qbmv.question_based_method_id = asm.question_based_method_id
        INNER JOIN answer_service ao ON asm.answer_service_id = ao.id
        INNER JOIN quiz_question_text qt ON qbmv.id = qt.versioned_quiz_id AND qt.language_code = 'JA'
        WHERE ao.alias = '＊防災クイズ_TSA様_0319'
        AND ar_qa.question_based_method_version_id IN (
          SELECT qbv.id AS question_based_method_version_id
          FROM answer_service ao
          INNER JOIN answer_service_method_bind asm ON ao.id = asm.answer_service_id
          INNER JOIN question_based_method_version qbv ON asm.question_based_method_id = qbv.question_based_method_id
          INNER JOIN quiz_option qo ON qbv.id = qo.question_based_method_version_id
          WHERE ao.alias = '＊防災クイズ_TSA様_0319'
          GROUP BY qbv.id
          HAVING COUNT(CASE WHEN qo.is_correct = 1 THEN 1 END) = COUNT(qo.id) )
        AND CONVERT_TZ(ar.answered_datetime, '+00:00', '+09:00') BETWEEN '2025-03-22 09:00:00' AND '2025-04-27 16:00:00'
        GROUP BY  ot.quiz_option_id
        ORDER BY selection_count DESC;
      `,
      database: "KpiDashboard",
      type: "list",
    }

    const [dataTempSurvey] = yield all([
      call(getDataFromSxi, sqlGetAllSurvey, ENDPOINT.GET_DATA_SXI_A2E, jwtToken),
    ]);

    // Set xAxisDate
    let recordArray = [];
    const dataToParse = dataTempSurvey.body === undefined ? [] : JSON.parse(dataTempSurvey.body);
    let eachSurveyData = {};
    // console.log("LOG:::", dataToParse);

    // // sort the mock order
    // const sortedSurveyData = _.orderBy(dataToParse, ['create_datetime'], ['desc']);

    _.each(dataToParse, function(data) {
        const startDate = moment(data.start_datetime);
        const endDate = moment(data.end_datetime);
        const now = moment.utc(); // Get the current UTC time

        eachSurveyData.status = now.isBefore(endDate) ? "Active" : "Ended";
        eachSurveyData.alias = data.alias;
        eachSurveyData.versionedQuizId = data.versioned_quiz_id;
        eachSurveyData.quizText = data.quiz_text;
        eachSurveyData.optionText = data.option_text;
        eachSurveyData.selectionCount = data.selection_count;
    //     eachSurveyData.clientName = data.answer_producer_alias;
    //     eachSurveyData.campaignId = data.answer_target_material_id; //data.answer_service_id;
        eachSurveyData.startDate = moment(startDate).tz("Asia/Tokyo").format('YYYY-MM-DD');
        eachSurveyData.endDate = moment(endDate).tz("Asia/Tokyo").format('YYYY-MM-DD');
        eachSurveyData.duration = endDate.diff(startDate, 'days') + 1;
        // アクティブの場合、残りの日数を計算
        if (eachSurveyData.status === "Active") {
          eachSurveyData.remainDays = endDate.diff(now, 'days') + 1; // 残りの日数に1日を足す
        } else {
          eachSurveyData.remainDays = 0;
        }
        recordArray.push(eachSurveyData);
        eachSurveyData = {};
    });

    yield put(setA2ESurvey(recordArray));
    yield put(setPageTopLoader(false));
  } catch (err) {
    console.log(err);
  }
}

export default function* watchPageSettings() {
  yield takeEvery(A2E.GET_A2E_SURVEY, getA2eSurvey);
}
